import React, { FC } from 'react';
import { AlertProps } from 'types';
import * as S from './styles';

export const Alert: FC<AlertProps> = props => {
	const { children } = props;
	return (
		<S.Alert {...props} role="alert">
			{children}
		</S.Alert>
	);
};

Alert.defaultProps = {
	intent: 'info',
	maxH: 12.5,
	maxW: 28.875,
	p: '0.75rem 3rem 0.75rem 0.75rem',
	position: 'relative',
};

export default Alert;
